var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shopping-bag",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_83154",
    "data-name": "Path 83154",
    d: "M40,0C71.046,0,80,8.954,80,40S71.046,80,40,80,0,71.046,0,40,8.954,0,40,0Z",
    fill: "#f2f3f7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-bag-2",
    "data-name": "shopping-bag",
    transform: "translate(26.087 26.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83330",
    "data-name": "Path 83330",
    d: "M7.638,2,3,8.184V29.826a3.092,3.092,0,0,0,3.092,3.092H27.734a3.092,3.092,0,0,0,3.092-3.092V8.184L26.188,2Z",
    transform: "translate(-3 -2)",
    fill: "none",
    stroke: "#636974",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_474",
    "data-name": "Line 474",
    x2: 27.826,
    transform: "translate(0 6.184)",
    fill: "none",
    stroke: "#636974",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83331",
    "data-name": "Path 83331",
    d: "M20.367,10A6.184,6.184,0,0,1,8,10",
    transform: "translate(-0.271 2.367)",
    fill: "none",
    stroke: "#636974",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBagIcon);
export default __webpack_public_path__ + "static/media/shoppingBag_icon.d3a4682c1a17a0c669a3b09b2ef54d05.svg";
export { ForwardRef as ReactComponent };